import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { useState } from 'react'

export default function DialogoReoptimizar({ onConfirmar, cambiosPendientes, sx }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Button variant="contained" color="secondary" onClick={() => setOpen(true)} sx={sx}>
        Reoptimizar
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Confirmar reoptimización</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {cambiosPendientes.length > 0
              ? `Hay ${cambiosPendientes} cambio(s) sin guardar. Se guardarán automáticamente antes de lanzar la reoptimización.`
              : 'Se lanzará una reoptimización con las asignaciones manuales guardadas.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button
            onClick={() => {
              setOpen(false)
              onConfirmar()
            }}
            variant="contained"
            color="secondary"
          >
            {cambiosPendientes > 0 ? 'Guardar y Reoptimizar' : 'Reoptimizar'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
